import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ValidationHandlerService} from '../validation-handler.service';

@Component({
  selector: 'achoo-toggle-switch',
  templateUrl: './achoo-toggle-switch.component.html',
  styleUrls: ['./achoo-toggle-switch.component.scss']
})
export class AchooToggleSwitchComponent extends AchooInputComponent<any> implements OnInit {

  @Output()
  switchChange = new EventEmitter<any>();

  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  switchChangeEvent(model) {
    this.switchChange.emit(model);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-toggle-switch/achoo-toggle-switch.component.ts